module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('van-pull-refresh', {
    attrs: {
      "success-text": "刷新成功"
    },
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('div', {
    staticClass: "hours_header"
  }, [_c('img', {
    ref: "imgHight",
    staticClass: "bg_header_img",
    style: ('background:#F6F6F6'),
    attrs: {
      "src": require("../images/bg.png")
    },
    on: {
      "load": _vm.loadImg
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "tab_list",
    attrs: {
      "id": "list_scroll"
    }
  }, [(_vm.data_.length > 0 || _vm.dataList.length > 0) ? _c('van-tabs', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "50"
    },
    on: {
      "click": _vm.changeID
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_vm._l(((_vm.data_.slice(0, 1))), function(v, index) {
    return _c('van-tab', {
      key: index,
      attrs: {
        "title": v.categoryInfo.name
      }
    }, [_c('ul', _vm._l((v.list), function(i, index) {
      return _c('div', {
        key: index
      }, [_c('h2', {
        staticClass: "date_",
        staticStyle: {
          "margin": "25px 0"
        }
      }, [_vm._v(_vm._s(index))]), _vm._v(" "), _vm._l((i), function(article, index) {
        return _c('div', {
          key: index,
          staticClass: "hours_list"
        }, [_c('div', {
          staticClass: "time_red"
        }, [_vm._v(_vm._s(_vm.getTime(article.date)))]), _vm._v(" "), _c('li', {
          staticClass: "flex flex-main-justify",
          on: {
            "click": function($event) {
              return _vm.goPath(article)
            }
          }
        }, [_c('div', {
          staticClass: "info",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('div', {
          class: ["title", "mult_line_ellipsis", article.images && article.images.length > 0 ? "min_height" : ""]
        }, [(article.tags && article.type === 'subject') ? _c('span', {
          staticClass: "tag_label_2"
        }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
          staticClass: "flex date"
        }, [_c('time', [_vm._v(_vm._s(_vm._f("dateComparedTime")(_vm.getDate(article.date))))]), _vm._v(" "), _c('span', {
          staticClass: "hours_tag likes_"
        }, [_vm._v(_vm._s(_vm.getCount(article.likes)))]), _vm._v(" "), _c('span', {
          staticClass: "comments hours_tag"
        }, [_vm._v(_vm._s(_vm.getCount(article.comments)))])])]), _vm._v(" "), (article.images) ? _c('div', {
          staticClass: "thumbnail",
          style: ({
            backgroundImage: 'url(' + article.images[0] + ')'
          })
        }, [_c('i', {
          class: [article.type + '-icon']
        })]) : _vm._e()])])
      })], 2)
    }), 0)])
  }), _vm._v(" "), _vm._l((_vm.nav), function(v) {
    return _c('van-tab', {
      key: v.id,
      attrs: {
        "title": v.name
      }
    }, [_c('ul', _vm._l((_vm.dataList.list), function(i, index) {
      return _c('div', {
        key: index
      }, [_c('h2', {
        staticClass: "date_",
        staticStyle: {
          "margin": "25px 0"
        }
      }, [_vm._v(_vm._s(index))]), _vm._v(" "), _vm._l((i), function(article, index) {
        return _c('div', {
          key: index,
          staticClass: "hours_list"
        }, [_c('div', {
          staticClass: "time_red"
        }, [_vm._v(_vm._s(_vm.getTime(article.date)))]), _vm._v(" "), _c('li', {
          staticClass: "flex flex-main-justify",
          on: {
            "click": function($event) {
              return _vm.goPath(article)
            }
          }
        }, [_c('div', {
          staticClass: "info",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('div', {
          class: ["title", "mult_line_ellipsis", article.images && article.images.length > 0 ? "min_height" : ""]
        }, [(article.tags && article.type === 'subject') ? _c('span', {
          staticClass: "tag_label_2"
        }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
          staticClass: "flex date"
        }, [_c('time', [_vm._v(_vm._s(_vm._f("dateComparedTime")(_vm.getDate(article.date))))]), _vm._v(" "), _c('span', {
          staticClass: "hours_tag likes_"
        }, [_vm._v(_vm._s(_vm.getCount(article.likes)))]), _vm._v(" "), _c('span', {
          staticClass: "comments hours_tag"
        }, [_vm._v(_vm._s(_vm.getCount(article.hits)))])])]), _vm._v(" "), (article.images) ? _c('div', {
          staticClass: "thumbnail",
          style: ({
            backgroundImage: 'url(' + article.images[0] + ')'
          })
        }, [_c('i', {
          class: [article.type + '-icon']
        })]) : _vm._e()])])
      })], 2)
    }), 0)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.noData == 0 || _vm.noData_ == 0) ? _c('div', {
    staticClass: "null-data",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("暂无相关内容")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "loading",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('spinner', {
    attrs: {
      "type": "fading-circle"
    }
  }), _vm._v("\n            加载中...\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAll) ? _c('p', {
    staticClass: "loading",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "50px"
    }
  }, [_vm._v("已显示全部内容")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ba3a936!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-24hours.vue
// module id = 842
// module chunks = 2